import { css } from "@emotion/css";
import React from "react";

interface Props {
  direction?: "row" | "column";
  justify?: "start" | "center" | "end";
  children: React.ReactNode;
  testID?: string;
}

export function ButtonGroup({
  direction = "row",
  justify,
  children,
  testID = "button-group",
}: Props) {
  return (
    <div
      className={css([
        styles.flexCentered,
        {
          flexDirection: direction,

          gap: "var(--space-2)",
          justifyContent: justify,
        },
        direction === "column" && {
          alignItems: "stretch",
        },
      ])}
      data-testid={testID}
    >
      {children}
    </div>
  );
}

const styles = {
  flexCentered: css({
    display: "flex",
    alignItems: "center",
  }),
};
